import React from 'react';
import moment from 'moment';
import { FieldElement } from '../component/field-element';
import { IFieldData } from './interface/field-data';
import { v4 as uuid } from 'uuid';

interface ITimeField {
  data: IFieldData;
  detail: FieldElement;
}

const TimeCustomField: React.FC<ITimeField> = (props) => {
  const currentDate = moment().format("YYYY-MM-DD");
  const dataTime = props.data.fields ? props.data.fields[props.detail.id] : '';
  let newDate = new Date(currentDate + ' ' + dataTime);
  let formattedTime: string = '';

  if (dataTime) {
    formattedTime = moment(newDate, 'HH:mm:ssZ').format('HH:mm:ss')
  }

  if (dataTime && typeof dataTime === 'object') {
    return dataTime.length > 0 && dataTime.map((time: string, index: number) => {
      let newTimeDate = new Date(currentDate + ' ' + time);
      let formatTime: string = '';

      if (time) {
        formatTime = moment(newTimeDate, 'HH:mm:ssZ').format('HH:mm:ss');
      }

      return (<div key={`column-${props.detail.id}-${props.data.id}-${uuid()}`}>
        <div>
          {formatTime || ''}
          {(dataTime.length > 1 && index < dataTime.length - 1) ? ',' : ''}
        </div>
      </div>)
    })
  }

  return (<div>
    <div key={`column-${props.detail.id}-${props.data.id}`}>
      {formattedTime || ''}
    </div>
  </div>)
}

export default TimeCustomField;